import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DxScrollViewModule } from 'devextreme-angular';

import { DynamicContainerComponent } from './components/dynamic-container/dynamic-container.component';
import { DynamicLoaderService } from './services/dynamic-loader.service';

@NgModule({
  declarations: [DynamicContainerComponent],
  imports: [CommonModule, RouterModule, PortalModule, DxScrollViewModule, TranslateModule],
  providers: [DynamicLoaderService],
})
export class SharedDynamicModule {}
